
import "primeflex/primeflex.css";
import { defineComponent } from "vue";
export default defineComponent({
  name: "App",
});
